<template>
    <div class="left-content">
        <div v-if="Number(type) !== 2" class="type-list">
            <span v-for="(val,index) in typeName" :key="index" :class="Number(type) === (index+1)?'select':''" @click="slectType(index+1)">{{val}}</span>
        </div>
        <div v-if="Number(type) === 2" class="type-list">
            <span v-for="(val,index) in peixundagangArr" :key="index" :class="peixundagangLevel === (index+1)?'select':''" @click="peixundagangLevel=index+1">{{val}}</span>
        </div>
        <div class="blank30"/>
        <div class="content_con" v-html="richContent"/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props:{
        type:{
            type:Number,
            defalut:() => 1,
        }
    },
    computed:
    mapState({
        richContent(state){
            let val;
            const richTextObj = state.richTextObj;
            if(Number(this.type) === 1){
                val = richTextObj.baokaotiaojian;
            }else if(Number(this.type) === 3){
                val = richTextObj.kaoheguifan;
            }else if(Number(this.peixundagangLevel) === 1){
                val = richTextObj.peixundagangchuji;
            }else{
                val = richTextObj.peixundagangzhongji;
            }
            return val;
        }
    }),
    data() {
        return {
            typeName:[
                '报考条件',
                '培训大纲',
                '考核规范',
            ],
            peixundagangArr:[
                '初级培训大纲',
                '中级培训大纲'
            ],
            peixundagangLevel:1,
        }
    },
    mounted() {
    },
    methods: {
        slectType(type){
            this.$emit('changeType',type);
        }
    },
}
</script>
<style lang="scss" scoped>
.type-list{
    display: flex;
    flex-direction: row;
    span{
        display: block;
        cursor: pointer;
        height: 49px;
        line-height: 49px;
        font-size: 20px;
        color: #333;
        margin-right: 20px;
        padding: 0 10px;
        font-weight: 400;
    }
    .select{
        font-weight: bold;
        border-bottom: 2px solid #224899;
        color: #224899;
    }
    span:hover{
        color:#224899;
    }
}
</style>
